import { LayoutGrid, RefreshCw, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useRebuildMatrix } from '@/hooks/use-admin';
import type { RebuildMatrixResult } from '@/hooks/use-admin';

function StatItem({ label, value }: { label: string; value: number }) {
  return (
    <div className="rounded-lg border p-3 text-center">
      <p className="text-2xl font-semibold">{value}</p>
      <p className="mt-0.5 text-xs text-muted-foreground">{label}</p>
    </div>
  );
}

export function MatrixBuilderCard() {
  const rebuildMatrix = useRebuildMatrix();
  const result = rebuildMatrix.data?.data as RebuildMatrixResult | undefined;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-sm">
          <LayoutGrid className="h-4 w-4" />
          Competence Matrix
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center gap-3">
          <Button
            size="sm"
            onClick={() => rebuildMatrix.mutate()}
            disabled={rebuildMatrix.isPending}
          >
            <RefreshCw
              className={`mr-1.5 h-3.5 w-3.5 ${rebuildMatrix.isPending ? 'animate-spin' : ''}`}
            />
            {rebuildMatrix.isPending ? 'Rebuilding...' : 'Rebuild Matrix'}
          </Button>
          <Link
            to="/matrix"
            className="inline-flex items-center gap-1 text-sm text-primary hover:underline"
          >
            Open Matrix
            <ExternalLink className="h-3.5 w-3.5" />
          </Link>
        </div>

        {rebuildMatrix.isError && (
          <p className="text-sm text-red-600 dark:text-red-400">
            Rebuild failed. Please try again.
          </p>
        )}

        {result && (
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
            <StatItem label="Members" value={result.memberCount} />
            <StatItem label="Total Skills" value={result.totalSkills} />
            <StatItem label="Gaps Found" value={result.gaps} />
            <StatItem label="Categories" value={result.categories} />
          </div>
        )}
      </CardContent>
    </Card>
  );
}
